// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"d3296caf","977":"b4ed0436"}[chunkId] + ".chunk.js";
};